import React, { useEffect, useState } from "react";

const CancelarLicencaModal = ({ show, onClose, onConfirm, loading = false }) => {
  const [motivo, setMotivo] = useState("");

  useEffect(() => {
    if (show) setMotivo("");
  }, [show]);

  if (!show) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    const m = motivo.trim();
    if (!m) return;
    onConfirm(m);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} aria-hidden="true" />
      <form
        onSubmit={handleSubmit}
        className="relative w-full max-w-md rounded-2xl zen-card p-6 shadow-xl dark:bg-slate-950/90 dark:border-white/10 space-y-4"
      >
        <h3 className="text-lg font-bold text-gray-900 dark:text-white">Cancelar licença</h3>
        <p className="text-sm text-gray-500 dark:text-slate-300">
          A licença sai da base ativa. O mês de cobrança permanece (sem estorno). Informe o motivo.
        </p>
        <textarea
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
          required
          rows={4}
          placeholder="Motivo do cancelamento"
          className="w-full px-3 py-2 rounded-xl border outline-none focus:ring-2 focus:ring-red-500/40 dark:bg-slate-950/40 dark:border-white/10 dark:text-white"
        />
        <div className="flex justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-xl border text-sm dark:border-white/10"
          >
            Voltar
          </button>
          <button
            type="submit"
            disabled={loading || !motivo.trim()}
            className="px-4 py-2 rounded-xl bg-red-600 text-white text-sm font-semibold disabled:opacity-50"
          >
            {loading ? "Cancelando..." : "Confirmar cancelamento"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CancelarLicencaModal;
